






import Vue from 'vue'
import { mapGetters } from 'vuex'
import Chatbot, {
    ChatbotSchemaContentType,
    ChatbotSchemaEntry,
    ChatbotStyles
} from '@/types/Chatbot.interface'
import Input from '@/types/Input.interface'
export default Vue.extend({
    data() {
        return {
            toolbar: {
                title: 'Chatbot',
                help: {
                    title: 'Chatbot',
                    body: 'Grow your text message subscriber list by starting conversations directly from your website with the MessageDesk Chatbot',
                    button: {
                        text: 'Learn More',
                        link: `${process.env.VUE_APP_URL_LEARN}/en/articles/5473493-chabot-overview`
                    }
                },
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/settings',
                        tooltip: 'Back',
                        permission: 0,
                        feature: null
                    }
                ],
                right: []
            }
        }
    },
    computed: {
        ...mapGetters({
            chatbots: 'chatbotsViewChatbots',
            defaultInputs: 'chatbotDefaultInputs',
            tenant: 'tenant'
        }),
        btnTxt(): string {
            //  If we have a chatbot then go there
            if (this.existingChatbot) return 'Edit Chatbot'

            //  else, we are creating
            return 'New Chatbot'
        },
        chatbotsCount(): number {
            return this.$store.getters.chatbotsCount
        },
        chatbotEnabled(): boolean {
            // return this.$store.getters.getEnabled('chatbot')
            return true
        },
        defaultSchema(): ChatbotSchemaEntry[] {
            //  Our inputs we want
            const fields = ['First Name', 'Last Name', 'Default Phone', 'Message']

            //  Grab our default inputs
            const defInputs = this.defaultInputs

            //  Create our container for inputs
            const inputs = defInputs.filter((x: Input) => fields.includes(x.name))

            //  Return our default schema
            return [
                {
                    content:
                        "Welcome! Please fill out the form below and we'll be in touch shortly.",
                    contentType: ChatbotSchemaContentType.text
                },
                {
                    contentType: ChatbotSchemaContentType.form,
                    content: {
                        name: 'inviteForm',
                        inputs: inputs,
                        complianceMessage: `By submitting the form you agree to receive promotional text messages from ${this.tenant.company_name} at the number provided. Consent is not a condition of purchase. Msg & data rates may apply. Msg frequency varies. Reply HELP for help. You may opt-out at anytime by replying STOP.`,
                        submitMessage: 'Submit',
                        successMessage:
                            'Thank you for submitting the form! We will contact you shortly.'
                    },
                    reciever: true
                }
            ]
        },
        defaultStyles(): ChatbotStyles {
            return {
                header: {
                    title: `${this.tenant.company_name} Chatbot`,
                    subtitle: `👋 Fill out this form so that we may contact you.`
                },
                colors: {
                    primary: '#6142B0',
                    secondary: '#8168C0',
                    background: '#F0F0F0',
                    bubbles: {
                        reciever: '#6142B0',
                        sender: '#949494'
                    }
                },
                agent: {
                    image: 'https://messagedesk-chatbot.s3.us-west-2.amazonaws.com/assets/media/agent1.jpg',
                    message: `Hey there 👋 Welcome to ${this.tenant.company_name}`,
                    disabled: false
                },
                icon: {
                    image: null
                }
            }
        },
        existingChatbot(): Chatbot {
            //  If chatbot is disabled, return null
            if (!this.chatbotEnabled) return null

            //  Else, return our first chatbot
            return this.chatbots[0] || null
        }
    },
    methods: {
        btnHandler(): void {
            //  If we have an existing chatbot, just route to it
            if (this.existingChatbot) return this.goToProfile()

            //  else, create a new chatbot
            this.createNewChatbot()
        },
        async createNewChatbot(): Promise<void> {
            // Create a chatbot request
            const chatbot = this.newChatbot()

            //  Send the request to the API
            const resp = await this.$store.dispatch('chatbotsPost', chatbot)

            //  If the request failed, do nothing
            if (!resp) return

            // Navigate to the chatbot
            this.goToProfile()
        },
        goToProfile(): void {
            //  Grab our id from our chatbot
            const id = this.existingChatbot.id

            //  Nav to the chatbot profile
            this.$router.push(`/chatbot/${id}?sender=${this.$route.path}`)
        },
        newChatbot(): Chatbot {
            return {
                object: 'Chatbot',
                name: `Chatbot_${new Date().toISOString()}`,
                schema: this.defaultSchema,
                styles: this.defaultStyles,
                response_message:
                    'Hey {{ FirstName }} thanks for filling out our form. How can we help you today?',
                response_enabled: true,
                allowed_domains: null
            } as Chatbot
        }
    }
})
